import { ReactNode } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

interface ProfileLayoutProps {
  title?: string;
  titleIcon?: ReactNode;
  showBack?: boolean;
  children?: ReactNode;
}

export function ProfileLayout({
  title,
  titleIcon,
  showBack = false,
  children,
}: ProfileLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="pageLayoutCss ">
      <main className="flex flex-col items-center w-full">
        <div className="w-full p-2">{children ?? <Outlet />}</div>

        {/* Curve with glow */}
        <div className="relative w-full overflow-hidden" style={{ height: '90px' }}>
          <div
            style={{
              position: 'absolute',
              width: '155%',
              height: '300px',
              left: '-30%',
              top: '50px',
              borderRadius: '50%',
              border: '2px solid #c87840',
              boxShadow: `
                0 0 20px rgba(255,83,38,0.6),
                0 0 40px rgba(255,83,38,0.45),
                0 0 80px rgba(255,83,38,0.25)
              `,
            }}
          />
        </div>
      </main>
    </div>
  );
}
